define([
	"dojo/_base/declare",
	"csi/def/Relationship",
	"csi/def/View",
	"csi/util"
], function(declare,Relationship,View,util) {

	return declare(View, {
		constructor: function(def) {
		    this.m_chartFile = util.getProperty(def, "Chart");
			this.m_chartWidth = util.getProperty(def, "Width");
			this.m_chartHeight = util.getProperty(def, "Height");
			this.m_relationship = util.getDef(def, "Relationship", Relationship);
		},

		resolve: function(/*Class*/rcRoot, /*Node*/nodeRoot, /*Boolean*/bConfigure) {
			var	lmap = this.getLocaleMap(rcRoot, bConfigure);

			if (this.m_relationship) {
				this.m_relationship.resolve(lmap, rcRoot, nodeRoot);
			}

			return this.inherited(arguments);
		},

		getRelationships: function() {
			return this.m_relationship ? [this.m_relationship] : null;
		},

		getPageRelationship: function() {
			return this.m_relationship;
		}
	});
});